import React from 'react';
import TopNavigation from './TopNavigation';
import './MainMenu.css';

const MainMenu = ({ onNavigate, onLogout }) => {
  const menuItems = [
    {
      id: 'vision-requirements',
      title: '비전검사 요구사항',
      description: '비전검사 시스템 요구사항 정의서 작성',
      icon: '🎯',
      color: '#3498db'
    },
    // 추후 추가할 메뉴들
    {
      id: 'schedule-management',
      title: '일정 관리',
      description: '프로젝트 일정 관리 및 추적',
      icon: '📅',
      color: '#9b59b6',
      disabled: false
    },
    {
      id: 'coming-soon-2',
      title: '데이터 관리',
      description: '곧 업데이트 예정',
      icon: '📊',
      color: '#95a5a6',
      disabled: true
    }
  ];

  const handleMenuClick = (menuId) => {
    if (menuId === 'vision-requirements') {
      onNavigate('requirements');
    } else if (menuId === 'schedule-management') {
      onNavigate('schedule');
    }
  };

  return (
    <div className="main-menu-container">
      <TopNavigation onBack={null} onLogout={onLogout} />
      
      <header className="main-header">
        <div className="header-content">
          <h1>한맥콘트롤즈 유틸리티</h1>
          <p>시스템 관리 및 설정 도구</p>
        </div>
      </header>

      <div className="menu-grid">
        {menuItems.map((item) => (
          <div
            key={item.id}
            className={`menu-item ${item.disabled ? 'disabled' : ''}`}
            onClick={() => !item.disabled && handleMenuClick(item.id)}
            style={{ '--item-color': item.color }}
          >
            <div className="menu-icon">
              {item.icon}
            </div>
            <div className="menu-content">
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>
            {!item.disabled && (
              <div className="menu-arrow">
                →
              </div>
            )}
          </div>
        ))}
      </div>

      <footer className="main-footer">
        <p>© 2024 한맥콘트롤즈. All rights reserved.</p>
        <p>버전 1.0.0</p>
      </footer>
    </div>
  );
};

export default MainMenu;